module.exports = __webpack_public_path__ + "static/media/cloudy-day-2.b931d84d.svg";